{
  "actions": {
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "close": "Cerrar"
  },
  "inputs": {
    "search_by_keyword": "Buscar..."
  },
  "standards": {
    "no_standard_data": "No hay datos estándar disponibles",
    "custom_standard_info": "Los estándares personalizados no tienen parámetros predefinidos: agregue los parámetros y sus niveles de alerta en el formulario.",
    "no_parameters_available": "No hay parámetros disponibles para este estándar y los dispositivos seleccionados.",
    "tabs": {
      "overview": "Resumen",
      "thresholds": "Umbrales"
    },
    "overview_statuses": "Cada parámetro se compara con los rangos de este estándar y obtiene uno de estos estados:",
    "score_title": "Índice de calidad del aire",
    "score_description": "Se calcula para cada marca de tiempo (0–100) como un promedio ponderado de los parámetros siguientes: un parámetro vale 100 cuando es bueno y baja hasta 0 al llegar a malo. Las marcas de tiempo a las que les falta alguno no tienen índice.",
    "no_score": "Este estándar no tiene índice de calidad del aire; los informes muestran solo los estados de los parámetros.",
    "weight": "%{weight}% del índice"
  },
  "unsaved_changes": {
    "title": "¿Salir sin guardar?",
    "text": "Los cambios de esta página no se han guardado. Si sales, se perderán.",
    "stay": "Quedarse",
    "leave": "Salir"
  }
}
